import { ChangeEvent, FC } from 'react';

import { Select } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { SORT_DROPDOWN_OPTIONS } from '../../constants';

type Props = {
    value: string;
    onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
    dataTest?: string;
};

export const SortDropdown: FC<Props> = ({ value, onChange, dataTest }) => {
    const { t } = useTranslations();

    const dropdownOptions = SORT_DROPDOWN_OPTIONS.map((option) => ({
        label: t[option.LABEL],
        value: option.VALUE,
    }));

    return (
        <Select
            aria-label={t['search.results.sort_title']}
            options={dropdownOptions}
            value={value}
            onChange={onChange}
            data-test={dataTest}
        />
    );
};
